import { TLotteryDrawEntry } from '@daymade/common-lib/dbJsonModels';
import { DataProvider } from '@plasmicapp/host';
import { useConfirmationData } from 'hooks/confirmation/useConfirmationData';
import { observer } from 'mobx-react-lite';
import React from 'react';

// Users will be able to set these props in Studio.
interface ConfirmationGlobalContextProps {
  // You might use this to override the auth URL to a test or local URL.
}

export const ConfirmationGlobalContext = observer(
  ({ children }: React.PropsWithChildren<ConfirmationGlobalContextProps>) => {
    const {
      loading,
      orderId,
      liteConfirmationPage,
      freeConfirmationPage,
      tuesdayDraw,
      fridayDraw,
      drawDates,
      entries,
      usedFreeSubscriptionDeal,
      promoCodeEntries,
      subscriptionEnabled,
      // ENG-394 - referralThreshold did not exist on useConfirmationData,
      orderCostMicro,
      subscriptionCosts,
      monthlyPayments,
    } = useConfirmationData();

    const parseEntries = (entry: TLotteryDrawEntry) => {
      // Split the input string by the '|' character

      // Create the object with the desired structure
      const result = {
        main1: entry.main[0],
        main2: entry.main[1],
        main3: entry.main[2],
        main4: entry.main[3],
        bonus: entry.bonus[0],
      };

      return result;
    };

    return (
      <DataProvider
        name="confirmation"
        data={{
          loading,
          orderId,
          liteConfirmationPage,
          freeConfirmationPage,
          tuesdayDraw,
          fridayDraw,
          drawDates,
          entries: entries && entries.map((entry) => parseEntries(entry)),
          usedFreeSubscriptionDeal,
          promoCodeEntries,
          subscriptionEnabled,
          // ENG-394 referralThreshold was not defined,
          orderCostMicro,
          subscriptionCosts,
          monthlyPayments,
        }}
      >
        {children}
      </DataProvider>
    );
  }
);
